// Bull Barber - Shopify Theme JS

// Spotlight effect on interactive cards
document.addEventListener('mousemove', function(e) {
  var cards = document.querySelectorAll('.glass-panel-interactive');
  cards.forEach(function(card) {
    var rect = card.getBoundingClientRect();
    if (
      e.clientX >= rect.left && e.clientX <= rect.right &&
      e.clientY >= rect.top && e.clientY <= rect.bottom
    ) {
      card.style.setProperty('--x', (e.clientX - rect.left) + 'px');
      card.style.setProperty('--y', (e.clientY - rect.top) + 'px');
    }
  });
});

// Scroll reveal (IntersectionObserver)
document.addEventListener('DOMContentLoaded', function() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in-up');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.scroll-reveal').forEach(function(el) {
    observer.observe(el);
  });
});

// Collection page: client-side filter
(function() {
  var input = document.getElementById('collection-filter');
  if (!input) return;
  input.addEventListener('input', function() {
    var q = this.value.toLowerCase();
    document.querySelectorAll('.collection-grid__item').forEach(function(item) {
      var title = item.getAttribute('data-title') || '';
      item.style.display = title.includes(q) ? '' : 'none';
    });
  });
})();

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(function(a) {
  a.addEventListener('click', function(e) {
    var target = document.querySelector(this.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});
